module.exports = __webpack_public_path__ + "static/media/elrich-life.7f61650d.png";